import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  recipient_email: Yup.string()
    .trim()
    .email('msg_error_invalid_email_format')
    .required('msg_error_required_field'),
});
